import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RfqsBulkSendOfferMessagesMutationVariables = Types.Exact<{
  input: Types.RfqsSendBulkMessagesInput;
}>;


export type RfqsBulkSendOfferMessagesMutation = { __typename?: 'Mutation', rfqsBulkSendOfferMessages?: { __typename?: 'RfqsSendBulkMessagesPayload', jobId: string } | null };


export const RfqsBulkSendOfferMessagesDocument = gql`
    mutation rfqsBulkSendOfferMessages($input: RfqsSendBulkMessagesInput!) {
  rfqsBulkSendOfferMessages(input: $input) {
    jobId
  }
}
    `;
export type RfqsBulkSendOfferMessagesMutationFn = Apollo.MutationFunction<RfqsBulkSendOfferMessagesMutation, RfqsBulkSendOfferMessagesMutationVariables>;

/**
 * __useRfqsBulkSendOfferMessagesMutation__
 *
 * To run a mutation, you first call `useRfqsBulkSendOfferMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRfqsBulkSendOfferMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rfqsBulkSendOfferMessagesMutation, { data, loading, error }] = useRfqsBulkSendOfferMessagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRfqsBulkSendOfferMessagesMutation(baseOptions?: Apollo.MutationHookOptions<RfqsBulkSendOfferMessagesMutation, RfqsBulkSendOfferMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RfqsBulkSendOfferMessagesMutation, RfqsBulkSendOfferMessagesMutationVariables>(RfqsBulkSendOfferMessagesDocument, options);
      }
export type RfqsBulkSendOfferMessagesMutationHookResult = ReturnType<typeof useRfqsBulkSendOfferMessagesMutation>;
export type RfqsBulkSendOfferMessagesMutationResult = Apollo.MutationResult<RfqsBulkSendOfferMessagesMutation>;
export type RfqsBulkSendOfferMessagesMutationOptions = Apollo.BaseMutationOptions<RfqsBulkSendOfferMessagesMutation, RfqsBulkSendOfferMessagesMutationVariables>;